module.exports = __webpack_public_path__ + "1a801daa09600c003f3691b97a01d770.svg";